export var objectSchemaToSelectOption = function objectSchemaToSelectOption(objectSchema) {
  return {
    label: objectSchema.name,
    value: objectSchema.id
  };
};